import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import cancel from "../assets/images/cancel-img.png";
import paid from "../assets/images/paid-img.png";
import {
  TERMS_AND_CONDITIONS,
  GSTIN,
  IFSC,
  ACCOUNT_NO,
  BANK_NAME,
  BRANCH_NAME,
} from "../constants";

function Invoice() {
  let { id } = useParams();

  const [orderList, setOrderList] = useState([]);
  const [invoiceData, setinvoiceData] = useState({});
  const [addressData, setAddressData] = useState({});
  const [webData, setWebData] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchOrderDetails();
  }, [id]);

  const fetchOrderDetails = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/view/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      if (data.success) {
        setOrderList(data.responseObject.products);
        setAddressData(data.responseObject.shippingAddress);
        setinvoiceData(data.responseObject);
      }
    } catch (error) {
      // console.log("Error fetching order details:", error);
    }
  };

  const calculateTotal = () => {
    return orderList
      .reduce((total, item) => {
        const basePrice = item?.price * item.quantity;
        const gstPercentage = item.product_id?.category_id?.C_GST || 0;
        const sgstPercentage = item.product_id?.category_id?.S_GST || 0;
        // const discount = item?.product_id?.discount_price || 0;
        const gstAmount = (basePrice * (gstPercentage + sgstPercentage)) / 100;
        return total + basePrice + gstAmount;
        // const discountedAmount = discount > 0
        //     ? (basePrice + gstAmount) * (1 - discount / 100)
        //     : basePrice + gstAmount;

        // return total + discountedAmount;
      }, 0)
      ?.toFixed(2);
  };
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format
    return `${hours}:${minutes}:${seconds} ${ampm}`;
    // return date.toISOString().split('T')[1].split('.')[0]; // Extract time portion
  };

  const calculateFinalPrice = () => {
    const subtotal = parseFloat(calculateTotal());
    if (invoiceData?.couponDetails?.discount > 0) {
      const discountAmount =
        (subtotal * invoiceData?.couponDetails?.discount) / 100;
      return (subtotal - discountAmount)?.toFixed(2);
    }
    return subtotal?.toFixed(2);
  };

  const handlePrint = () => {
    window.print();
  };

  const printStyles = `
    @media print {
      .no-print {
        display: none !important;
      }
      body {
        padding: 20px;
        background: white;
      }
      .invoice-main {
        border: none !important;
        box-shadow: none !important;
      }
    }
  `;

  return (
    <>
      <style>{printStyles}</style>
      <div
        className="invoice-main"
        style={{
          backgroundImage: `url(${
            invoiceData?.status == "Cancelled" ? cancel : paid
          })`,
        }}
      >
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <h5
                  style={{
                    fontSize: 26,
                    fontWeight: "bolder",
                    color: "#000",
                    textAlign: "center",
                  }}
                >
                  TAX INVOICE
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ width: "100%", border: "1px solid #000" }}>
          <tbody>
            <tr>
              <td
                style={{ width: "50%", border: "1px solid #000", padding: 5 }}
              >
                <img src="{logo}" alt="" style={{ width: 90 }} />
                <div>
                  <h4
                    style={{
                      fontSize: 20,
                      fontWeight: "bolder",
                      color: "#000",
                    }}
                  >
                    Sweetz N'snackz
                  </h4>
                  <p>
                    <span>
                      {" "}
                      {webData?.address}, {webData?.contact} ,
                    </span>
                    <br />
                    {webData?.email}
                  </p>
                </div>
              </td>
              <td
                style={{
                  width: "50%",
                  border: "1px solid #000",
                  textAlign: "center",
                }}
              >
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <p>
                          {" "}
                          <b>Invoice No.</b> <br /> SW/001{" "}
                        </p>
                      </td>
                      <td style={{ width: "50%" }}>
                        <p>
                          {" "}
                          <b>Invoice Date</b> <br />
                          {new Date().toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          className="invoice-header mb-4"
          style={{ width: "100%", border: "1px solid #000", padding: 10 }}
        >
          <div className="row">
            <div className="col-6">
              <h4>Invoice Details</h4>
              <p>
                <strong>Invoice No:</strong> INV-
                {invoiceData._id?.slice(-8).toUpperCase()}
              </p>
              <p>
                <strong>Order Date:</strong>{" "}
                {new Date(invoiceData.createdAt).toLocaleString()}
              </p>
              {invoiceData.status === "cancelled" && (
                <p>
                  <strong>Cancelled Date:</strong>{" "}
                  {new Date(
                    invoiceData.cancellationDetails?.cancelledAt
                  ).toLocaleString()}
                </p>
              )}
              <p>
                <strong>Status:</strong>{" "}
                <span
                  className={`p-2 rounded text-white  ${
                    invoiceData.status === "cancelled"
                      ? "bg-danger"
                      : "bg-success"
                  }`}
                >
                  {invoiceData.status?.toUpperCase()}
                </span>
              </p>
            </div>
            <div className="col-6 text-end">
              {/* <img src={logo} alt="Logo" style={{ maxWidth: "150px" }} /> */}
              <p className="mt-2">Sweetz N'snackz</p>
              <p>GSTIN: {GSTIN}</p>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-4">
              <h5>Customer Details</h5>
              <p>
                <strong>Name:</strong> {invoiceData.user?.firstName}{" "}
                {invoiceData.user?.lastName}
              </p>
              <p>
                <strong>Email:</strong> {invoiceData.user?.email}
              </p>
              <p>
                <strong>Mobile:</strong> {invoiceData.user?.mobile}
              </p>
            </div>
            <div className="col-4"></div>
            <div className="col-4">
              <h5>Shipping Address</h5>
              <p>{invoiceData.shippingAddress?.street}</p>
              <p>
                {invoiceData.shippingAddress?.city},{" "}
                {invoiceData.shippingAddress?.district},{" "}
                {invoiceData.shippingAddress?.state}
              </p>
              <p>{invoiceData.shippingAddress?.postalCode}</p>
              <p>{invoiceData.shippingAddress?.country}</p>
            </div>
          </div>
        </div>
        <table style={{ width: "100%" }}>
          <thead style={{ backgroundColor: "#CFE9F9", color: "#000" }}>
            <tr>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                S.NO.
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Product ID
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Product Name
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Weight (g)
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Unit Price
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Quantity
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Discount %
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                CGST
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                SGST
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                IGST
              </th>
              <th
                style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {orderList.map((item, index) => (
              <tr key={item._id}>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {index + 1}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.productId.productId}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.productId.productName}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.weightId.weightInGrams}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  ₹{item.price}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.quantity}
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.productId.discount_percentage}%
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.cgst}%
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.sgst}%
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  {item.igst}%
                </td>
                <td
                  style={{ border: "1px solid #000", padding: 5, fontSize: 12 }}
                >
                  ₹{(item.discountedTotalPrice + item.totalTax)?.toFixed(2)}
                </td>
              </tr>
            ))}
            <tr>
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
              <td style={{ border: "1px solid #000" }} />
            </tr>
          </tbody>
          <tfoot style={{ backgroundColor: "transparent", color: "#000" }}>
            <tr>
              <td colSpan="7" style={{ border: "1px solid #000", padding: 5 }}>
                <strong>Summary</strong>
              </td>
              <td style={{ border: "1px solid #000", padding: 5 }}>
                ₹{invoiceData.totalCGST?.toFixed(2)}
              </td>
              <td style={{ border: "1px solid #000", padding: 5 }}>
                ₹{invoiceData.totalSGST?.toFixed(2)}
              </td>
              <td style={{ border: "1px solid #000", padding: 5 }}>
                ₹{invoiceData.totalIGST?.toFixed(2)}
              </td>
              <td style={{ border: "1px solid #000", padding: 5 }}>
                <strong>₹{invoiceData.amountWithTax?.toFixed(2)}</strong>
              </td>
            </tr>
            {invoiceData.discountAmount > 0 && (
              <tr>
                <td
                  colSpan="9"
                  style={{ border: "1px solid #000", padding: 5 }}
                >
                  <strong>Coupon Discount</strong>
                </td>
                <td style={{ border: "1px solid #000", padding: 5 }}>
                  -₹{invoiceData.discountAmount}
                </td>
              </tr>
            )}
            <tr>
              <td colSpan="9" style={{ border: "1px solid #000", padding: 5 }}>
                <strong>Final Amount</strong>
              </td>
              <td style={{ border: "1px solid #000", padding: 5 }}></td>
              <td style={{ border: "1px solid #000", padding: 5 }}>
                <strong>₹{invoiceData.finalAmount?.toFixed(2)}</strong>
              </td>
            </tr>
          </tfoot>
        </table>
        <table
          style={{
            width: "100%",
            border: "1px solid #000",
            marginTop: 15,
            borderBottom: "none",
          }}
        >
          <tbody>
            <tr>
              {/* <td style={{ padding: 10 }}>
                                <p>
                                    Total Amount (in words) <br />
                                    <strong>Two Hundred Rupees only</strong>
                                </p>
                            </td> */}
            </tr>
          </tbody>
        </table>

        {invoiceData.status === "cancelled" && (
          <div
            className="cancellation-info"
            style={{ width: "100%", border: "1px solid #000", padding: 10 }}
          >
            <h5 className="text-danger border-bottom pb-2">
              <i className="fas fa-ban me-2"></i>
              Order Cancellation Details
            </h5>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <strong>Cancelled By:</strong>{" "}
                  {invoiceData.cancellationDetails?.cancelledBy}
                </p>
                <p>
                  <strong>Reason:</strong>{" "}
                  {invoiceData.cancellationDetails?.reason}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <strong>Cancelled On:</strong>{" "}
                  {new Date(
                    invoiceData.cancellationDetails?.cancelledAt
                  ).toLocaleString()}
                </p>
                <p>
                  <strong>Payment Status:</strong>
                  <span
                    className={`p-2 rounded text-white  ${
                      invoiceData.paymentStatus === "refunded"
                        ? "bg-success"
                        : "bg-warning"
                    } ms-2`}
                  >
                    {invoiceData.paymentStatus?.toUpperCase()}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
        <table
          className="payment-info mt-4 p-4"
          style={{ width: "100%", border: "1px solid #000", padding: 10 }}
        >
          <h5>Payment Information</h5>
          <table style={{ width: "100%", marginTop: 10, padding: 10 }}>
            <tbody>
              <tr>
                <td style={{ padding: 5 }}>
                  <strong>Payment Status:</strong>
                </td>
                <td style={{ padding: 5 }}>
                  <span
                    className={`p-2 rounded text-white  ${
                      invoiceData.paymentStatus === "completed"
                        ? "bg-success"
                        : "bg-warning"
                    }`}
                  >
                    {invoiceData.paymentStatus?.toUpperCase()}
                  </span>
                </td>
              </tr>
              <tr>
                <td style={{ padding: 5 }}>
                  <strong>Payment Method:</strong>
                </td>
                <td style={{ padding: 5 }}>Online Payment</td>
              </tr>
            </tbody>
          </table>
        </table>
        <table style={{ width: "100%", border: "1px solid #000" }}>
          <tbody>
            <tr>
              <td
                style={{ width: "33%", padding: 10, border: "1px solid #000" }}
              >
                <h4 style={{ fontSize: 18 }}>Bank Details</h4>
                <p>
                  Name: <span> Sweetz N'snackz</span>
                </p>
                <p>
                  IFSC Code: <span>{IFSC}</span>
                </p>
                <p>
                  Account No: <span>{ACCOUNT_NO}</span>
                </p>
                <p>
                  Bank:{" "}
                  <span>
                    {BANK_NAME} ,{BRANCH_NAME}{" "}
                  </span>
                </p>
              </td>
              <td
                style={{ width: "33%", border: "1px solid #000", padding: 10 }}
              >
                <p>Terms and Conditions</p>
                <p>{TERMS_AND_CONDITIONS}</p>
              </td>
              <td
                style={{
                  width: "33%",
                  padding: 10,
                  borderBottom: "1px solid #000",
                }}
              >
                <p style={{ marginBottom: 40 }}>For </p>
                <p>Sweetz N'snackz (Authorised Signatory ) </p>
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{ width: "100%", border: "1px solid #000", borderTop: 0 }}
        >
          <tbody>
            <tr>
              <td style={{ padding: 8 }}>
                <h4 style={{ fontSize: 18 }}>Terms &amp; Conditions</h4>
                <p>
                  1. If you have any issues or queries in respect of your order,
                  please contact customer chat support through the sweetznsnackz
                  platform or drop in email at info@sweetznsnack.com.
                </p>
                <p>
                  2. In case you need to get more information about the seller's
                  FSSAI status, please visit https://foscos.fssai.gov.in/ and
                  use the FBO search option with the FSSAI License /
                  Registration number.
                </p>
                <p>
                  3. Please note that we never ask for bank account details such
                  as CVV, account number, UPI Pin, etc. across our support
                  channels. For your safety please do not share these details
                  with anyone over any medium.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-4 mb-4 no-print">
        <button
          onClick={handlePrint}
          className="btn btn-primary"
          style={{
            padding: "10px 30px",
            fontSize: "16px",
            borderRadius: "5px",
            backgroundColor: "#3c3260",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <i className="fas fa-print me-2"></i>
          Print Invoice
        </button>
      </div>
    </>
  );
}

export default Invoice;
